import { updatePageLoadingApi } from '@slice/select.slice';
import AdminLogApi from 'apis/api/AdminLog';
import OrderManagerApi from 'apis/api/OrderManager';
import moment from 'moment';
import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { clampDebtAmounts } from '../../layoutContentUWR/hook/debtOrderFilter';
import { THU_NO_NHAP_THEM } from './hook/thuNoAllocation';

export const useOrderDebtLogic = (
  form: any,
  listCSKH: string[],
  dataDebtOrder: any,
  netAmountForDebt: number,
  options: { autoFetch?: boolean } = {},
  rowSelected?: any,
  setTotalDuNo?: (value: number) => void, // <-- NEW
  isQuickCreatingDebt?: React.MutableRefObject<boolean> // NEW
) => {
  // Hooks/XuLyDonNo.ts
  const processOrderData = useCallback(
    (rawOrders: any[]) => {
      const groupedOrders: any[] = [];
      const invoiceMap: Record<string, any> = {};

      // Sửa: dùng selectedOrders (đúng field thực tế), khóa theo (type + maDonHang)
      // để nhất quán với processOrderData bên CreateOrders.tsx
      const makeSelectKey = (type: any, maDonHang: any) => `${type === 2 ? 'INV' : 'ORD'}_${maDonHang}`;
      const selectedKeys = new Set(
        (rowSelected?.selectedOrders || []).map((item: any) => makeSelectKey(item.type, item.maDonHang))
      );

      (THU_NO_NHAP_THEM ? rawOrders.map(clampDebtAmounts) : rawOrders).forEach((o: any) => {
        if (o.type === 2) {
          if (!invoiceMap[o.maDonHang]) {
            invoiceMap[o.maDonHang] = {
              ...o,
              tienNo: 0,
              thuVat: 0,
              thuChenhLech: 0,
              goiCuoc: 0,
              tienSanPham: 0,
              tienPhi: 0,
              tienCong: 0,
              orderType: o.loai,
              isGroup: true,
              childIds: [],
              childItems: []
            };
            groupedOrders.push(invoiceMap[o.maDonHang]);
          }
          invoiceMap[o.maDonHang].tienNo +=
            (o.thuVat || 0) +
            (o.thuChenhLech || 0) +
            (o.tienPhi || 0) +
            (o.tienCong || 0) +
            (o.tienSanPham || 0) +
            (o.goiCuoc || 0);
          invoiceMap[o.maDonHang].thuVat += o.thuVat || 0;
          invoiceMap[o.maDonHang].thuChenhLech += o.thuChenhLech || 0;
          invoiceMap[o.maDonHang].tienSanPham += o.tienSanPham || 0;
          invoiceMap[o.maDonHang].tienPhi += o.tienPhi || 0;
          invoiceMap[o.maDonHang].goiCuoc += o.goiCuoc || 0;
          invoiceMap[o.maDonHang].tienCong += o.tienCong || 0;
          invoiceMap[o.maDonHang].childIds.push(o.id);
          invoiceMap[o.maDonHang].childItems.push(o);
        } else {
          groupedOrders.push({ ...o, isGroup: false, orderType: o.loai });
        }
      });

      return groupedOrders.map((o: any) => {
        const shouldCheck = selectedKeys.has(makeSelectKey(o.type, o.maDonHang)); // sửa chỗ so khớp
        return {
          ...o,
          checked: shouldCheck,
          originalTotal: o.tienNo,
          ngay: o.ngay ? moment(o.ngay).format('DD/MM/YYYY') : '-'
        };
      });
    },
    [netAmountForDebt, rowSelected]
  );

  // const processOrderData = useCallback(
  //   (rawOrders: any[]) => {
  //     const groupedOrders: any[] = [];
  //     const invoiceMap: Record<string, any> = {};

  //     // So khớp "đã chọn" bằng maDonHang cho cả đơn group và đơn lẻ.
  //     // KHÔNG dùng o.id vì API danhSachDonNo trả id = 0 cho mọi dòng (không unique).
  //     const selectedKeys = new Set((rowSelected?.danhSachDonNo || []).map((item: any) => item.maDonHang));

  //     rawOrders.forEach((o: any) => {
  //       if (o.type === 2) {
  //         if (!invoiceMap[o.maDonHang]) {
  //           invoiceMap[o.maDonHang] = {
  //             ...o,
  //             tienNo: 0,
  //             thuVat: 0,
  //             thuChenhLech: 0,
  //             goiCuoc: 0,
  //             tienSanPham: 0,
  //             tienPhi: 0,
  //             tienCong: 0,
  //             orderType: o.loai,
  //             isGroup: true,
  //             childIds: [],
  //             childItems: []
  //           };
  //           groupedOrders.push(invoiceMap[o.maDonHang]);
  //         }
  //         invoiceMap[o.maDonHang].tienNo +=
  //           (o.thuVat || 0) +
  //           (o.thuChenhLech || 0) +
  //           (o.tienPhi || 0) +
  //           (o.tienCong || 0) +
  //           (o.tienSanPham || 0) +
  //           (o.goiCuoc || 0);
  //         invoiceMap[o.maDonHang].thuVat += o.thuVat || 0;
  //         invoiceMap[o.maDonHang].thuChenhLech += o.thuChenhLech || 0;
  //         invoiceMap[o.maDonHang].tienSanPham += o.tienSanPham || 0;
  //         invoiceMap[o.maDonHang].tienPhi += o.tienPhi || 0;
  //         invoiceMap[o.maDonHang].goiCuoc += o.goiCuoc || 0;
  //         invoiceMap[o.maDonHang].tienCong += o.tienCong || 0;
  //         invoiceMap[o.maDonHang].childIds.push(o.id);
  //         invoiceMap[o.maDonHang].childItems.push(o);
  //       } else {
  //         groupedOrders.push({ ...o, isGroup: false, orderType: o.loai });
  //       }
  //     });

  //     return groupedOrders.map((o: any) => {
  //       const shouldCheck = selectedKeys.has(o.maDonHang);

  //       return {
  //         ...o,
  //         checked: shouldCheck,
  //         originalTotal: o.tienNo,
  //         ngay: o.ngay ? moment(o.ngay).format('DD/MM/YYYY') : '-'
  //       };
  //     });
  //   },
  //   [netAmountForDebt, rowSelected]
  // );

  const mergeWithServerData = useCallback((apiOrders: any[], serverCheckedCodes: string[]) => {
    if (!serverCheckedCodes || serverCheckedCodes.length === 0) {
      return apiOrders; // Không có server data → giữ nguyên logic processOrderData
    }

    const serverSet = new Set(serverCheckedCodes);

    return apiOrders.map(order => ({
      ...order,
      // Server đã chọn đơn nào thì force checked: true, bỏ qua netAmountForDebt
      checked: serverSet.has(order.maDonHang) ? true : false
      // Các đơn KHÔNG nằm trong server list → checked: false
      // dù netAmountForDebt có đủ hay không
    }));
  }, []);

  const onSaleChange = useCallback(
    async (vals?: string[], serverCheckedCodes?: string[], serverItems?: any[]) => {
      if (isQuickCreatingDebt?.current) return; // NEW: chặn sớm ngay từ đầu hàm

      let finalVals = vals.includes('') ? (vals[vals.length - 1] === '' ? [''] : vals.filter(v => v !== '')) : vals;
      if (finalVals.length === 0) finalVals = [''];

      const currentItems = form?.getFieldValue('ThuNoItems') || [{}];
      currentItems[0] = { ...currentItems[0], listKinhDoanh: finalVals };
      form.setFieldsValue({ ThuNoItems: [...currentItems] });

      if (setTotalDuNo) {
        const saleNamesForDebt = finalVals.includes('GROUP_CSKH')
          ? finalVals.filter(v => v !== 'GROUP_CSKH').concat(listCSKH)
          : finalVals;

        const hasSelection = !saleNamesForDebt.includes('') && saleNamesForDebt.length > 0;

        const selectedStaffItems = hasSelection
          ? (dataDebtOrder?.listKinhDoanh || []).filter((staff: any) => saleNamesForDebt.includes(staff.saleAccount))
          : [];

        const newTotalDuNo = dataDebtOrder?.isUsed
          ? 0
          : selectedStaffItems.reduce((totalAcc: number, staff: any) => {
              const staffDuNo =
                staff.cooperations?.reduce((coopAcc: number, coop: any) => coopAcc + (coop.duNo || 0), 0) || 0;
              return totalAcc + staffDuNo;
            }, 0);

        setTotalDuNo(newTotalDuNo);
      }

      // 3. Gọi API
      const phone = dataDebtOrder?.phoneList?.[0]?.phone;
      if (!phone) return;

      const apiParam = finalVals.includes('GROUP_CSKH')
        ? finalVals.filter(v => v !== 'GROUP_CSKH').concat(listCSKH)
        : finalVals;

      // Đơn đã hoàn tất (4) hoặc đã hủy (5): danh sách đơn nợ không còn thay đổi nữa
      // → không gọi lại API LayDanhSachDonNo, chỉ dùng dữ liệu server đã trả sẵn
      // (serverItems) để dựng lại finalItems

      const orderStatus = rowSelected?.status.statusValue;
      const isFinalOrCancelled = orderStatus === '4' || orderStatus === '5';

      if (isFinalOrCancelled) {
        if (serverItems && serverItems.length > 0) {
          const serverSet = new Set(serverCheckedCodes || []);
          const finalItems = serverItems
            .map((item: any) => ({
              ...(THU_NO_NHAP_THEM ? clampDebtAmounts(item) : item),
              checked: serverCheckedCodes && serverCheckedCodes.length > 0 ? serverSet.has(item.maDonHang) : true
            }))
            .sort((a: any, b: any) => {
              if (a.checked === b.checked) return 0;
              return a.checked ? -1 : 1;
            });

          const currentItems = form?.getFieldValue('ThuNoItems') || [{}];
          currentItems[0] = { ...currentItems[0], listKinhDoanh: finalVals };
          currentItems[0].inDebtOrderCodes = finalItems;

          form.setFieldsValue({ ThuNoItems: [...currentItems] });
        }
        return;
      }

      try {
        const res = await OrderManagerApi.LayDanhSachDonNo({
          customerPhone: phone,
          saleNames: apiParam.includes('') ? [] : apiParam
        });

        if (res.data && !res.data.error) {
          const apiData = res.data.data || [];

          let finalItems: any[];

          if (serverCheckedCodes && serverCheckedCodes.length > 0 && serverItems) {
            const apiData = res.data.data || [];

            // Lấy tất cả maDonHang từ API (bao gồm cả childItems nếu có)
            const apiCodesSet = new Set(
              apiData.flatMap((o: any) =>
                o.loai === 'Hóa Đơn' && o.childItems?.length > 0
                  ? o.childItems.map((c: any) => c.maDonHang)
                  : [o.maDonHang]
              )
            );

            // Lấy maDonHang đại diện của từng serverItem để so sánh
            const getMaDonHangRepresent = (item: any): string[] => {
              if (item.isGroup && item.childItems?.length > 0) {
                return item.childItems.map((c: any) => c.maDonHang);
              }
              return [item.maDonHang];
            };

            // Đơn server mà API không trả về bất kỳ child nào → append nguyên cấu trúc
            const missingFromApi = serverItems.filter((serverItem: any) => {
              const codes = getMaDonHangRepresent(serverItem);
              return codes.every(code => !apiCodesSet.has(code));
            });

            // processOrderData chỉ chạy trên apiData (đã có loai đầy đủ)
            const processedApi = processOrderData(apiData);

            // Append missingFromApi sau (giữ nguyên cấu trúc isGroup/childItems từ server)
            // Chỉ cần reset checked về đúng state
            const processedMissing = missingFromApi.map((item: any) => ({
              ...(THU_NO_NHAP_THEM ? clampDebtAmounts(item) : item),
              checked: true // Đơn từ server đã chọn → luôn true
            }));

            const serverSet = new Set(serverCheckedCodes);
            const processedApiWithCheck = processedApi.map((order: any) => ({
              ...order,
              checked: serverSet.has(order.maDonHang) ? true : false
            }));

            finalItems = [...processedApiWithCheck, ...processedMissing];
          } else {
            // Không có server data → chạy bình thường với netAmountForDebt
            finalItems = processOrderData(apiData);
          }

          // === ĐOẠN CODE THAY ĐỔI: Sắp xếp các đơn checked: true lên đầu ===
          finalItems.sort((a, b) => {
            if (a.checked === b.checked) return 0;
            return a.checked ? -1 : 1; // Đẩy true lên trước ( trả về -1), false về sau (trả về 1)
          });
          // =============================================================

          const currentItems = form.getFieldValue('ThuNoItems') || [{}];

          currentItems[0] = { ...currentItems[0], listKinhDoanh: finalVals };
          currentItems[0].inDebtOrderCodes = finalItems;
          form.setFieldsValue({ ThuNoItems: [...currentItems] });
        }
      } catch (e) {
        console.error('Lỗi lấy danh sách đơn nợ', e);
      }
    },
    [dataDebtOrder, listCSKH, processOrderData, form, isQuickCreatingDebt]
  );

  return { onSaleChange };
};

export const useAdminConfig = (configKey: string) => {
  const [configValue, setConfigValue] = useState<number>(0);
  const [newValue, setNewValue] = useState<any>([]);
  const dispatch = useDispatch();

  const fetchConfig = async () => {
    // Bật loading
    dispatch(updatePageLoadingApi(true));

    try {
      if (['UseManageReturnProduct', 'UserApproveDebtOrder', 'EditInVoice', 'UpdateTienThuNo']?.includes(configKey)) {
        const res = await AdminLogApi.GetConfigWithKey(configKey);

        if (!res.data.error) {
          // Ép kiểu về Number như logic gốc của bạn
          // const value = Number(res.data.data.data);
          // const newValue = res.data.data.data;
          // setConfigValue(value);
          // setNewValue(newValue);
          const allowedUsers = res.data.data.data ? res.data.data.data.split(',') : [];
          setNewValue(allowedUsers);
        }
      } else {
        const res = await AdminLogApi.GetConfigWithKey(configKey);

        if (!res.data.error) {
          // Ép kiểu về Number như logic gốc của bạn
          const value = Number(res.data.data.data);
          setConfigValue(value);
        }
      }
    } catch (error) {
      console.error(`Error fetching config for ${configKey}:`, error);
    } finally {
      // Tắt loading (đặt trong finally để luôn chạy dù thành công hay lỗi)
      dispatch(updatePageLoadingApi(false));
    }
  };

  useEffect(() => {
    if (configKey) {
      fetchConfig();
    }
  }, [configKey]);

  // Trả về giá trị và hàm refetch nếu cần gọi lại
  return { configValue, newValue, refetch: fetchConfig };
};
